module.exports = __webpack_public_path__ + "static/media/stickers.faf8e893.svg";